import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import circles from '../../../../images/optimum-hero-circles.svg';
import bg from '../../../../images/pco_circles_half.png';
import bgWithDot from '../../../../images/pco_circles_half_with_dot.png';

// * Main Wrapper for the hero banner
export const OptimumCircleVariationsWrapperStyles = css`
  &.hero-with-optimum-circles {
    min-height: 500px;
    padding: 30px;
    padding-bottom: 0;
    text-align: center;
    overflow: hidden;
    background: linear-gradient(
      to bottom,
      ${themeGet('colors.pc-red', '#E1251B')} 60%,
      transparent 40%
    );

    &::after {
      content: '';
      display: block;
      background-image: url(${circles});
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: -70px;
      top: -50px;
      transform: rotate(-30deg);
      height: 253px;
      width: 310px;
      z-index: 0;
    }
  }

  &.hero-with-optimum-half-circles {
    padding: 30px;
    min-height: 750px;
    text-align: center;
    overflow: hidden;
    background: ${themeGet('colors.pc-red', '#E1251B')};

    &:after {
      content: '';
      display: block;
      background-image: url(${bg});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      height: 115px;
      width: 108px;
      top: 30%;
      right: -54px;
    }

    &:before {
      content: '';
      display: block;
      background-image: url(${bgWithDot});
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      height: 244px;
      width: 287px;
      left: -100px;
      bottom: -130px;
      transform: rotate(5deg);
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    &.hero-with-optimum-half-circles {
      min-height: 700px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    &.hero-with-optimum-circles {
      min-height: 400px;
      padding: 75px 35px 0;
      text-align: left;
      background: linear-gradient(
        to bottom,
        ${themeGet('colors.pc-red', '#E1251B')} 70%,
        transparent 40%
      );

      &::after {
        transform: none;
        right: -50px;
        top: -65px;
        height: 270px;
        width: 331px;
      }
    }

    &.hero-with-optimum-half-circles {
      min-height: 350px;
      padding: 30px 0 65px 35px;
      text-align: left;

      &:after {
        height: 131px;
        width: 122px;
        top: 10px;
        right: -62px;
      }

      &:before {
        height: 244px;
        width: 287px;
        left: 35%;
        bottom: -118px;
        transform: rotate(0deg);
      }
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    &.hero-with-optimum-circles {
      min-height: 525px;
      padding: 75px 40px 10px;

      &::after {
        right: -25px;
        top: -125px;
        height: 363px;
        width: 442px;
      }
    }

    &.hero-with-optimum-half-circles {
      padding: 50px 0 80px 58px;
    }
  }
`;

// * Styling for the Div that wraps all the text copy
export const OptimumCircleVariationsContentStyles = css`
  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles & {
    position: relative;
    z-index: 1;
  }

  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
    position: relative;
    z-index: 1;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${OptimumCircleVariationsWrapperStyles}.hero-variation-5 & {
      margin-right: 25px;
    }

    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
      max-width: 50%;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
      max-width: 515px;
    }
  }
`;

// * Styling for the heading inside the content box
export const OptimumCircleVariationsTitleStyles = css`
  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles &,
  .hero-with-optimum-half-circles & {
    color: ${themeGet('colors.white')};
  }

  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles & {
    + a,
    button {
      margin-top: 349px;
    }
  }

  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
    color: ${themeGet('colors.white')};
    font-family: ${themeGet('fonts.noir')};
    font-size: 55px;
    font-weight: ${themeGet('fontWeights.medium')};
    letter-spacing: 0;
    line-height: 56px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles & {
      font-size: ${({ lang }) => (lang === 'en' ? '54px' : '42px')};
      line-height: ${({ lang }) => (lang === 'en' ? '1.3' : '1.5')};
      letter-spacing: -0.26px;
      + a,
      button {
        margin-top: 112px;
      }
    }

    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
      font-size: 50px;
      font-weight: ${themeGet('fontWeights.medium')};
      letter-spacing: 0;
      line-height: 55px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles & {
      font-size: ${({ lang }) => (lang === 'en' ? '102px' : '78px')};
      line-height: ${({ lang }) => (lang === 'en' ? '1.04' : '1.25')};
      letter-spacing: -0.5px;
      + a,
      button {
        margin-top: ${({ lang }) => (lang === 'en' ? '125px' : '135px')};
      }
    }
  }
`;

// * Intro body copy below the heading in the hero
export const OptimumCircleVariationsIntroStyles = css`
  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles & {
    margin: 2rem auto 0;
    max-width: 640px;
    width: 100%;

    p {
      color: ${themeGet('colors.white')};
    }
  }

  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
    margin: 2rem auto 0;
    max-width: 640px;
    width: 100%;

    p {
      color: ${themeGet('colors.white')};
    }
  }
`;

// * The Div that wraps the CTA in the Hero
export const OptimumCircleVariationsCTAWrapperStyles = css`
  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles & {
    padding-top: 22rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      padding-top: 6rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      padding-top: 8rem;
    }
  }

  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
    padding-top: 11rem;
    align-items: center;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      padding-top: 60vw;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      padding-top: 50px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    }
  }
`;

export const OptimumCircleVariationsMediaContainerStyles = css`
  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles & {
    margin: 0;
    z-index: 1;
    position: absolute;
    top: ${({ lang }) => (lang === 'en' ? '160px' : '200px')};
    right: 50%;
    transform: translateX(50%);
    width: 255px;
  }

  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
    margin: 0;
    z-index: 1;
    position: absolute;
    right: 50%;
    transform: translateX(50%);
    bottom: 12.5%;
    width: calc(100% - 40px);
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles & {
      top: ${({ lang }) => (lang === 'en' ? '125px' : '160px')};
    }

    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
      bottom: 15%;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles & {
      width: 259px;
      right: 35px;
      top: 83px;
      transform: none;
    }

    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
      width: 40%;
      min-width: 325px;
      right: 0px;
      top: 50%;
      transform: translateY(-50%);
      bottom: unset;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles & {
      width: 422px;
      position: absolute;
      right: 62px;
      top: 49px;
    }

    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
      width: 422px;
      position: absolute;
      right: 62px;
      top: 49px;
      transform: none;
    }
  }
`;

export const OptimumCircleVariationsHeroImageStyles = css`
  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles & {
    margin: 0;
    height: 318px;
  }

  ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
    margin: 0;
    height: auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-circles & {
      margin: 0;
      height: 100%;
      width: 100%;
    }

    ${OptimumCircleVariationsWrapperStyles}.hero-with-optimum-half-circles & {
      margin: 0;
      height: 270px;
      height: 100%;
      width: 100%;
    }
  }
`;
